import { render, staticRenderFns } from "./PhotoHeader.vue?vue&type=template&id=71d2c920&scoped=true&"
import script from "./PhotoHeader.vue?vue&type=script&lang=ts&"
export * from "./PhotoHeader.vue?vue&type=script&lang=ts&"
import style0 from "./PhotoHeader.vue?vue&type=style&index=0&id=71d2c920&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71d2c920",
  null
  
)

export default component.exports